<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleAdd(scope.row,scope.index)"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_WORK_ITEM_DEL"
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_WORK_ITEM_DEL_TRUE"
            @click.stop="handleDel('DELETE_OPTION','物理删除')"
          >物理删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleView(scope.row,scope.index)"
          >查看</el-button>
        </template>

        <template
          slot-scope="scope"
          slot="nameForm"
        >
          <!-- <el-select v-model="currClassify" clearable placeholder="请选择系统大类">
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.rootName"
              :value="item.id"
            ></el-option>
          </el-select>-->
          <el-select
            v-model="currClassify"
            filterable
            remote
            reserve-keyword
            placeholder="请输入手机号"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { serviceDrawOption } from "@/const/work/serviceDrawOption";
import { findPercentage, delItem } from "@/api/work/serviceDraw";

export default {
  name: "serviceDraw",
  data() {
    return {
      tableOption: serviceDrawOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findPercentage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findPercentage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;

      console.log(params);
      findPercentage(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      findPercentage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      // this.clean();
      // this.$refs.crud.rowAdd();
      let obj = {
        label: "新增服务抽成",
        value: "serviceDraw/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
    },
    handleEdit(row, index) {
      console.log(row, index);
      let obj = {
        label: "编辑服务抽成",
        value: "serviceDraw/edit",
        query: { id: row.id, aname: row.name }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleView(row, index) {
      console.log(row, index);
      let obj = {
        label: "查看服务抽成",
        value: "serviceDraw/view",
        query: { id: row.id, aname: row.name }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findPercentage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      addTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delItem(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      editTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
